import { Component } from '@angular/core';
import { MatTabNav, MatTabLink, MatTabNavPanel } from '@angular/material/tabs';
import { RouterLinkActive, RouterLink, RouterOutlet } from '@angular/router';
import { PageTabsComponent } from '@next/core-lib/components';
import { TranslatePipe } from '@next/core-lib/i18n';

@Component({
  selector: 'height-measurement-component',
  templateUrl: './height-measurement.component.html',
  styleUrls: ['./height-measurement.component.scss'],
  imports: [
    PageTabsComponent,
    MatTabNav,
    MatTabLink,
    RouterLinkActive,
    RouterLink,
    MatTabNavPanel,
    RouterOutlet,
    TranslatePipe,
  ],
})
export class HeightMeasurementComponent {}
